import React, { ReactElement } from 'react';
import LiveMatchPoint from '../LiveMatchPoint/LiveMatchPoint';
import LiveMatchCountDown from '../LiveMatchCountDown/LiveMatchCountDown';
import LiveMatchResult from '../LiveMatchResult/LiveMatchResult';
import { useSelector } from 'react-redux';
import { AppState } from '../../../../store/store';

const LiveMatch = (): ReactElement => {
  const { liveMatchData } = useSelector((state: AppState) => state.liveMatch);

  const renderLiveMatch = () => {
    if (liveMatchData) {
      return (
        <>
          {liveMatchData.kind == 'vs' && <LiveMatchPoint />}
          <LiveMatchCountDown />
          <LiveMatchResult />
        </>
      );
    } else {
      return <></>;
    }
  };

  return <>{renderLiveMatch()}</>;
};
export default LiveMatch;
